var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 35",
    style: {
      enableBackground: "new 0 0 56 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M52,0H4C1.8,0,0,1.8,0,4v27c0,2.2,1.8,4,4,4h48c2.2,0,4-1.8,4-4V4C56,1.8,54.2,0,52,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F9FC",
    d: "M52,35H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h48c2.2,0,4,1.8,4,4v27C56,33.2,54.2,35,52,35z M4,1 C2.3,1,1,2.4,1,4v27c0,1.7,1.3,3,3,3h48c1.7,0,3-1.3,3-3V4c0-1.7-1.3-3-3-3H4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Logo_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.2116,
    y1: 26.5386,
    x2: 51.2116,
    y2: 11.5386,
    gradientTransform: "matrix(1 0 0 -1 0 35.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25479E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#242D6A"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Logo_1_)",
    d: "M28.8,14.8c0,2.1,1.8,3.3,3.3,3.9c1.5,0.7,1.9,1.2,1.9,1.8c0,1-1.2,1.4-2.2,1.4c-1.9,0-3-0.5-3.8-0.9 l-0.7,3.2c0.9,0.4,2.5,0.8,4.1,0.8c3.9,0,6.5-1.9,6.5-5c0-3.8-5.2-4-5.2-5.8c0-0.5,0.5-1.1,1.6-1.2c0.5-0.1,2-0.1,3.7,0.7l0.7-3.1 c-0.9-0.3-2.1-0.6-3.5-0.6C31.4,10,28.8,12,28.8,14.8z M44.8,10.3c-0.7,0-1.3,0.4-1.6,1.1l-5.6,13.4h3.9l0.8-2.2h4.8l0.5,2.2H51 l-3-14.5H44.8z M45.4,14.2l1.1,5.4h-3.1L45.4,14.2z M24.1,10.3L21,24.8h3.7l3.1-14.5H24.1z M18.6,10.3l-3.9,9.9l-1.6-8.4 c-0.2-0.9-0.9-1.5-1.7-1.5H5.1L5,10.7c1.3,0.3,2.8,0.7,3.7,1.2c0.5,0.3,0.7,0.6,0.9,1.3l3,11.6h3.9l6-14.5H18.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.da7f80bb.svg";
export { ForwardRef as ReactComponent };